import { Button, Row, Space, TablePaginationConfig, Tooltip } from "antd";
import useLocationList from "../../Hooks/Location/useLocationList";
import { FilterValue } from "antd/es/table/interface";
import { useState } from "react";
import { TLocation } from "../../types/Location/TLocation";
import UserAutoComplete from "../User/UserAutoComplete";
import { PlusOutlined, SyncOutlined } from "@ant-design/icons";
import SearchInput from "../../Utils/SearchInput";
import LocationTable from "./LocationTable";
import locationRepo from "../../API/LayoutApi/location.repo";
import LocationAddForm from "./LocationAddForm";
import LocationEditForm from "./LocationEditForm";

function LocationPage() {
  const {
    userId,
    setUserId,
    setPage,
    search,
    setSearch,
    setIsActive,
    isLoading,
    isFetching,
    data,
    refetch,
  } = useLocationList();

  function onChangeTable(
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>
  ) {
    setPage(pagination.current as number);
    if (
      !filters.is_active ||
      (filters.is_active && filters.is_active.length === 2)
    ) {
      setIsActive("");
    } else if (filters.is_active && filters.is_active.length === 1) {
      setIsActive(String(filters.is_active[0]));
    }
  }

  const [addFormOpen, setAddFormOpen] = useState(false);
  const [editFormOpen, setEditFormOpen] = useState(false);
  const [editLocation, setEditLocation] = useState<TLocation>();

  function openEditForm(location: TLocation) {
    setEditLocation(location);
    setEditFormOpen(true);
  }

  return (
    <div>
      <Row align="top" justify="space-between" style={{ marginBottom: 16 }}>
        <Space>
          <UserAutoComplete value={userId} onChange={setUserId} />
          <SearchInput value={search} onDebounceChange={setSearch} />
        </Space>
        <Space>
          <Button
            onClick={() => setAddFormOpen(true)}
            type="primary"
            icon={<PlusOutlined />}
          >
            Add Location
          </Button>
          <Tooltip title="Refresh">
            <Button
              onClick={() => refetch()}
              loading={isFetching}
              icon={<SyncOutlined />}
            />
          </Tooltip>
        </Space>
      </Row>
      <LocationTable
        data={data}
        isLoading={isLoading || isFetching}
        onEdit={openEditForm}
        onChange={onChangeTable}
        deleteData={(id: string) => locationRepo.locationDelete(id)}
        refetch={() => refetch()}
      />
      <LocationAddForm
        open={addFormOpen}
        setOpen={setAddFormOpen}
        onSubmit={() => refetch()}
      />
      {editLocation && (
        <LocationEditForm
          initialValue={editLocation}
          open={editFormOpen}
          setOpen={setEditFormOpen}
          onSubmit={() => refetch()}
        />
      )}
    </div>
  );
}

export default LocationPage;
